// DataTableShell.jsx
import React, { useEffect, useMemo } from "react";
import { Table } from "reactstrap";
import { injectSkeletonStyles } from "./TableSkeleton";
import { TableSkeleton } from "./TableSkeleton";
import { EmptyState } from "./EmptyState";

export const DataTableShell = ({
  headers = [],
  rows = [],
  isLoading = false,
  emptyProps = {},
  rowRenderer,
}) => {
  useEffect(() => {
    injectSkeletonStyles?.(); // safe-call if undefined
  }, []);

  const colCount = useMemo(() => Math.max(headers.length, 1), [headers]);

  const defaultRowRenderer = (row, idx) => (
    <tr key={idx}>
      {headers.map((_, i) => {
        const keys = Object.keys(row);
        const k = keys[i] ?? keys[0];
        return <td key={`${idx}-${i}`}>{String(row?.[k] ?? "—")}</td>;
      })}
    </tr>
  );

  return (
    <div className="data-table-shell-scroll">
      <Table className="tablesorter mb-0">
      <thead className="text-primary">
        <tr>
          {headers.map((h, i) => (
            <th key={i}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {isLoading ? (
          <TableSkeleton columns={colCount} />
        ) : rows.length ? (
          rows.map(rowRenderer || defaultRowRenderer)
        ) : (
          <tr>
            <td colSpan={colCount}>
              <EmptyState {...emptyProps} />
            </td>
          </tr>
        )}
      </tbody>
    </Table>
    </div>
  );
};
